export { default, getStaticProps } from '../../src/pages/Guides'
